<template>
  <div class="empty-state">
    <!-- <img :src="imgSrc" alt="empty state image" /> -->
    <p class="empty-state-text" :style="{ height: height + 'px', h: h + '%' }">{{ message }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    // imgSrc: {
    //   type: String,
    //   required: true,
    // },
    message: {
      type: String,
      required: true,
    },
    height: {
      type: [Number, String],
    },
    h: {
      type: [Number, String],
    },
  },
};
</script>

<style lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  justify-content: justify-content;
  align-items: center;
  font-size: 16px;
  color: #999;
  position: relative;
  .empty-state-text {
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    font-size: 16px;
    color: #999;
  }
}
</style>
